import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';
import { html } from '../utils/environment';
import { lerp } from '../utils/maths';
import config from '../config';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        window.scrollTo(0,0);

        this.hasScrolledValue = config.IS_MOBILE ? 50 : 200;

        setTimeout(() => {
            this.speed = 0;
            this.lerpedSpeed = 0;
            this.render();

            this.scroll = new LocomotiveScroll({
                el: this.el,
                smooth: false,
                offset: ['10%'],
                getSpeed: true
            });

            this.scroll.on('call', (func,way,obj,id) => {
                // Using modularJS
                this.call(func[0],{way,obj},func[1],func[2]);
            });
    
            this.scroll.on('scroll', (args) => {
                if(args.scroll.y > this.hasScrolledValue) {
                    html.classList.add('has-scrolled');
                } else {
                    html.classList.remove('has-scrolled');
                }

                if(!isNaN(args.speed)) {
                    this.speed = args.speed;
                }

                // this.call('onScroll',args,'Rail');

                // if(typeof args.currentElements['cta-contact'] === 'object') {
                //     let progress = args.currentElements['cta-contact'].progress;
                //     // console.log(progress);
                //     this.backgroundTween.progress(progress);
                // }
            })
        }, 600)
    }
    
    render() {
        this.raf = requestAnimationFrame(() => this.render());

        this.speed = lerp(this.speed, 0, 0.1);
        this.lerpedSpeed = lerp(this.lerpedSpeed, this.speed, 0.1);

        if(Math.abs(this.lerpedSpeed) < 0.1) {
            html.classList.remove('is-scrolling');
        } else {
            html.classList.add('is-scrolling');
        }
    }

    toggleLazy(args) {
        let src = this.getData('lazy', args.obj.el)
        if(src.length) {
            if(args.obj.el.tagName == "IMG") {
                args.obj.el.src = src
            } else {
                args.obj.el.style.backgroundImage = `url(${src})`
            }
            this.setData('lazy', '', args.obj.el)
        }
    }

    scrollTo(param) {
        const target = param?.target || param
        const options = param?.options || {}
        this.scroll?.scrollTo(target, options);
    }

    update() {
        this.scroll?.update?.();
    }

    destroy() {
        this.scroll?.destroy?.();

        if(this.raf !== undefined) {
            cancelAnimationFrame(this.raf);
        }
    }
}
